import ScheduleEvent from "@/schedule/entities/schedule-event";
import ScheduleGateway from "@/schedule/usecases/schedule-gateway";
import { format, parse } from "date-fns";
import ClientLike from "../client-like";
import ScheduleEventSaveRequest from "@/schedule/usecases/schedule-event-save-request";
import formatDate from "@/helpers/formatDate";
import toScheduleEvent from "./to-schedule-event";

export default class ScheduleEventApi implements ScheduleGateway {
  public constructor(private client: ClientLike) {}

  /**
   * idで絞り込む
   */
  public async find(id: number): Promise<ScheduleEvent | undefined> {
    const data = await this.client.get("get_schedule_event.php", {
      scheduleId: id
    });
    if (data.events.length) {
      return toScheduleEvent(data.events[0]);
    }
  }

  /**
   * 利用者と日付で予定を絞り込む
   */
  public async findByUserAndDate(
    userId: number,
    date: Date
  ): Promise<ScheduleEvent[]> {
    const data = await this.client.get("get_schedule_event.php", {
      userId,
      date: formatDate(date)
    });
    return data.events.map(toScheduleEvent);
  }

  /**
   * 予定を保存する
   */
  public async save(event: ScheduleEventSaveRequest): Promise<void> {
    const d = new FormData();
    d.append("scheduleId", String(event.id || ""));
    d.append("projectId", String(event.projectId || ""));
    // TODO APIで対応してもらう
    d.append(
      "start",
      format(parse(event.startTime, "H:mm", event.date), "yyyy-MM-dd HH:mm:ss")
    );
    d.append(
      "end",
      format(parse(event.endTime, "H:mm", event.date), "yyyy-MM-dd HH:mm:ss")
    );
    d.append("title", event.title);
    d.append("description", event.description);
    await this.client.post("save_schedule.php", d);
  }

  /**
   * 予定を削除する
   */
  public async delete(id: number): Promise<void> {
    const d = new FormData();
    d.append("scheduleId", String(id));
    await this.client.post("delete_schedule.php", d);
  }
}
